"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      tableData: [], // 列表数据
      searchData: {
        username: '',
        isSuperuser: '',
        page: 1, // 当前页码
        rows: 10 // 页码条数
      },

      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 } };


  },
  filters: {
    isSuperuserFilter: function isSuperuserFilter(val) {
      if (val === 0) {
        return '否';
      } else if (val === 1) {
        return '是';
      } else {
        return val;
      }
    } },

  mounted: function mounted() {
    var self = this;
    self.init();
  },
  methods: {
    init: function init() {
      var self = this;
      self.getData('/api/mqttuser', self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },

    resetFun: function resetFun() {// 重置
      this.searchData.username = '';
      this.searchData.isSuperuser = '';
      this.init();
    },

    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    changeisSuperuserFun: function changeisSuperuserFun(val) {
      var self = this;
      if (val === 0) {
        self.searchData.isSuperuser = 0;
      }if (val === 1) {
        self.searchData.isSuperuser = 1;
      }
    } } };exports.default = _default;